module.exports = __webpack_public_path__ + "static/media/DistractionTechniques.0881c015.mp3";